module.exports = __webpack_public_path__ + "static/media/profile.284bcb5e.png";